import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from '../link';
import { NormalizeClassNameString, PreventDOMLock } from '../utils';

export class Pagination extends React.Component {

    constructor(props, ...others) {
        super(props, ...others);
        
        this.handleGoPage = this.handleGoPage.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        const props = this.props;

        let result = 
            (props.pageNum != nextProps.pageNum) ||
            (props.pagesCount != nextProps.pagesCount) ||
            (props.disabled != nextProps.disabled) ||
            (props.onPageSelect != nextProps.onPageSelect) ||
            (props.maxButtons != nextProps.maxButtons) ||
            (props.className != nextProps.className) ||
            (props.showFirst != nextProps.showFirst) ||
            (props.showPrev != nextProps.showPrev) ||
            (props.showNext != nextProps.showNext) ||
            (props.showLast != nextProps.showLast) ||
            (props.size != nextProps.size);
            
        return result;
    }

    handleGoPage(e) {
        const pageNum = parseInt(e.currentTarget.getAttribute('data-pn'));

        if (!isNaN(pageNum)) {
            const self = this;
            PreventDOMLock(() => self.props.onPageSelect(pageNum));
        }
    }

    render() {
        const self = this;
        const {maxButtons, disabled, pageNum, pagesCount, size, showFirst, showLast, showNext, showPrev, className} = self.props;

        const sizeClass = Boolean(size) ? ' pagination-' + size : '';
        const _maxButtons = Math.max(1, maxButtons);

        const buttons = [];
        const firstButton = Math.max(1, Math.min(pagesCount, Math.ceil(pageNum + (_maxButtons - 1) / 2)) - _maxButtons + 1);
        for (var i = firstButton; (buttons.length < _maxButtons) && (i <= pagesCount); i++) {
            const isLast = (i == pagesCount) || (buttons.length == _maxButtons - 1);
            buttons.push(
                <li className={'page-item page-num ' + (i == pageNum ? ' active' : '') + (isLast ? '' : ' has-separator')} key={'pbtn-' + i}>
                    <Link 
                        className="page-link sh-paging-number" 
                        disabled={disabled}
                        data-pn={i}
                        to={(i == pageNum) ? Link.preventDefault : self.handleGoPage} 
                    >
                        {i}
                    </Link>
                </li>
            )
        }

        return (
            <ul className={NormalizeClassNameString('pagination flex-wrap' + sizeClass + (Boolean(className) ? ' ' + className : ''))}>
                {showFirst &&
                    <li className="page-item">
                        <Link 
                            className="page-link sh-paging-first" 
                            data-pn={1}
                            to={self.handleGoPage} 
                            disabled={(pageNum <= 1) || disabled}
                        >
                            <span className="fa fa-angle-double-left"/>
                        </Link>
                    </li>
                }
                {showPrev &&
                    <li className="page-item">
                        <Link 
                            className="page-link sh-paging-prev" 
                            data-pn={pageNum - 1}
                            to={self.handleGoPage}
                            disabled={(pageNum <= 1) || disabled}
                        >
                            <span className="fa fa-angle-left"/>
                        </Link>
                    </li>
                }
                {buttons}
                {showNext &&
                    <li className="page-item">
                        <Link 
                            className="page-link sh-paging-next" 
                            data-pn={pageNum + 1}
                            to={self.handleGoPage} 
                            disabled={(pageNum >= pagesCount) || disabled}
                        >
                            <span className="fa fa-angle-right"/>
                        </Link>
                    </li>
                }
                {showLast &&
                    <li className="page-item">
                        <Link 
                            className="page-link sh-paging-last" 
                            //data-pn={pagesCount}
                            data-pn="2147483647" // max int in c#
                            to={self.handleGoPage} 
                            disabled={(pageNum >= pagesCount) || disabled}
                        >
                            <span className="fa fa-angle-double-right"/>
                        </Link>
                    </li>
                }
            </ul>            
        )
    }
}
Pagination.propTypes = {
    onPageSelect: PropTypes.func.isRequired,
    pagesCount: PropTypes.number.isRequired,
    pageNum: PropTypes.number.isRequired,
    maxButtons: PropTypes.number,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'lg']),
    showFirst: PropTypes.bool,
    showPrev: PropTypes.bool,
    showNext: PropTypes.bool,
    showLast: PropTypes.bool,
    className: PropTypes.string
}
Pagination.defaultProps = {
    disabled: false,
    maxButtons: 7,
    showFirst: true,
    showPrev: true,
    showNext: true,
    showLast: true,
}